import { AfterViewInit, Component, OnInit } from '@angular/core';
import { AdminService } from 'src/app/services/admin.service';
import { SharedService } from 'src/app/services/sharedService';

@Component({
    selector: 'app-admin',
    templateUrl: './admin.component.html',
    styleUrls: ['./admin.component.css'],
    standalone: false
})
export class AdminComponent implements OnInit, AfterViewInit {
  admin: any;

  /**
   * The languages this deployment offers.
   *
   * English is fixed. It is the fallback every other bundle degrades to -- the
   * French file still has 78 keys equal to their English text -- so a
   * deployment without it renders those keys as their own names. The checkbox
   * is disabled for that reason, and the SERVER enforces the same rule, because
   * a disabled checkbox is a convention and the endpoint is reachable without
   * one.
   */
  readonly requiredLanguage = 'en';
  readonly optionalLanguages = ['fr', 'nl'];
  selectedLanguages: string[] = ['en'];

  /**
   * Whether CERBERE -- the controls module -- appears in the top menu.
   *
   * Read from the /modules endpoint rather than from the settings record,
   * because an unset value means "whatever the config file says" and only the
   * server knows that. Reading the EFFECTIVE value keeps the checkbox from
   * claiming the module is on while the menu hides it.
   */
  controlsModuleEnabled = false;

  constructor(private adminService: AdminService, private sharedService: SharedService) {
    this.admin = {};
   }

  isLanguageOffered(code: string): boolean {
    return code === this.requiredLanguage || this.selectedLanguages.indexOf(code) !== -1;
  }

  toggleLanguage(code: string): void {
    if (code === this.requiredLanguage) return;
    const at = this.selectedLanguages.indexOf(code);
    if (at === -1) this.selectedLanguages.push(code);
    else this.selectedLanguages.splice(at, 1);
  }
   ngAfterViewInit(): void {
    this.sharedService.loadMenuItems('admin');
  }

  ngOnInit() {
    this.adminService.getAdminSettings()
    .subscribe(settings => {
      if (settings && settings.length > 0) {
      this.admin = settings[0];
      // A deployment that has never saved this has no languages field; en + fr
      // is what every existing deployment already offers, so that is what an
      // unset value means rather than "English only".
      this.selectedLanguages = Array.isArray(this.admin.languages)
        ? this.admin.languages.slice()
        : ['en', 'fr'];
      if (this.selectedLanguages.indexOf(this.requiredLanguage) === -1) {
        this.selectedLanguages.unshift(this.requiredLanguage);
      }
      }

    });

    this.adminService.modules$().subscribe(configuration => {
      this.controlsModuleEnabled = configuration?.modules?.controls ?? false;
    });
  }


  onSubmit() {
    // Sent explicitly rather than bound with ngModel: the checkboxes describe a
    // set, and English belongs in it whether or not anything ticked it.
    this.admin.languages = [this.requiredLanguage]
      .concat(this.optionalLanguages.filter(code => this.selectedLanguages.indexOf(code) !== -1));

    // Sent explicitly for the same reason as the languages above: the checkbox
    // describes a choice, and it has to be stored as one even when it matches
    // what the config file already said. An absent value means "no choice made"
    // and falls back to the config file, which is not the same thing.
    this.admin.modules = Object.assign({}, this.admin.modules,
      { controls: this.controlsModuleEnabled });

    this.adminService.saveAdminSettings(this.admin)
      .subscribe(settings => {
        this.admin = settings;
        // The header read the module list once, when it was built. Without this
        // the menu keeps CERBERE until the next full page load, and turning it
        // off looks like it did nothing.
        this.sharedService.updateToken.emit(true);
      });
  }

}
